import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function respNfInvalido({ nome, email }) {
  return !nome.trim() || !EMAIL_RE.test(email.trim());
}

export function ResponsavelNfFields({ value, onChange, pessoas = [], required = false, semNf = false }) {
  const comEmail = pessoas.filter((p) => p.email);
  const usarPessoa = (pid) => {
    const p = comEmail.find((x) => x.id === pid);
    if (p) onChange({ nome: p.nome, email: p.email });
  };
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-3 space-y-2" data-testid="resp-nf-bloco">
      <div className="text-sm font-bold text-amber-900 flex items-center gap-1.5">
        <Mail className="w-4 h-4" /> Responsável pelo recebimento da NF{required ? " *" : ""}
      </div>
      <p className="text-[11px] text-amber-800">{semNf ? "Opcional — inscrição só de cortesia não gera NF." : "O Fiscal envia a nota fiscal para este e-mail."}</p>
      {comEmail.length > 0 && (
        <select value="" onChange={(e) => usarPessoa(e.target.value)} className="w-full h-9 rounded-md border border-slate-200 px-2 text-sm bg-white" data-testid="resp-nf-pessoa">
          <option value="">Preencher com uma pessoa do município…</option>
          {comEmail.map((p) => <option key={p.id} value={p.id}>{p.nome} · {p.email}</option>)}
        </select>
      )}
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Label className="text-xs">Nome{required ? " *" : ""}</Label>
          <Input value={value.nome} onChange={(e) => onChange({ ...value, nome: e.target.value })} placeholder="Nome do responsável" data-testid="resp-nf-nome" />
        </div>
        <div>
          <Label className="text-xs">E-mail{required ? " *" : ""}</Label>
          <Input type="email" value={value.email} onChange={(e) => onChange({ ...value, email: e.target.value })} placeholder="email@camara.gov.br" data-testid="resp-nf-email" />
        </div>
      </div>
    </div>
  );
}
